import { rem } from 'polished';
import styled from '../../../styles/theme';
import { TrimItemStyled } from '../TrimItemStyled';

export const TrimItemStyledDS = styled(TrimItemStyled)`
    .trimContainer {
        .header {
            .title {
                font-size: ${rem('22px')};
                line-height: ${rem('22px')};
                color: ${({ theme }) => theme.colors.black1};
                &--detail {
                    font-weight: bold;
                }
            }
        }
        .equipmentSubtitle {
            p {
                font-weight: normal;
                color: #767676;
                margin: 0.5rem 0;
            }
        }

        .priceInfo {
            text-align: center;
            margin-top: ${rem(10)};
        }

        .priceInfo__text {
            color: ${({ theme }) => theme.colors.grey1};
            font-size: ${rem('16px')};
        }

        .options {
            font-family: ${({ theme }) => theme.fonts.fontBase};
            .colorOption {
                .colorButtonWrapper {
                    height: ${rem('22px')};

                    button {
                        height: ${rem('22px')};
                        width: ${rem('22px')};
                        border-radius: 0;
                    }
                }
            }

            .engineOption {
                margin-left: 2rem;
                .engineIcon,
                .engineIcon svg {
                    height: ${rem('22px')};
                    width: ${rem('22px')};
                }
            }
        }

        .equipmentList__info {
            font-size: ${rem('16px')};
        }

        .equipmentList__list--item {
            font-size: ${rem('16px')};
            position: relative;

            &::before {
                content: '';
                width: ${rem(4)};
                height: ${rem(4)};
                position: absolute;
                top: ${rem(8)};
                left: ${rem(-8)};
                background: ${({ theme }) => theme.colors.grey1};
                border-radius: 50%;
            }
        }

        .equipmentList__list {
            list-style: none;
            font-family: ${({ theme }) => theme.fonts.fontBase};
        }

        .benefits {
            .heading {
                font-size: ${rem('16px')};
                line-height: ${({ theme }) => theme.lineHeights.h3};
            }
            .bullet-header {
                font-size: ${rem('16px')};
            }
            ul {
                list-style: none;

                &.bullet-points {
                    padding-left: ${rem(8)};
                    li {
                        &::before {
                            content: '';
                            width: ${rem(4)};
                            height: ${rem(4)};
                            background: ${({ theme }) => theme.colors.grey1};
                            border-radius: 50%;
                            min-width: ${rem(4)};
                            margin-right: ${rem(5)};
                        }
                    }
                    .offer {
                        font-family: ${({ theme }) => theme.fonts.fontBase};
                        box-shadow: none;
                        display: flex;
                        align-items: flex-start;
                        justify-content: space-between;
                        font-size: ${rem('16px')};
                        .tooltip {
                            margin-left: 1rem;
                        }
                        .tooltip,
                        .tooltip svg {
                            height: ${rem('16px')};
                            width: ${rem('16px')};
                        }

                        .icon-wrapper {
                            height: ${rem('16px')};

                            svg {
                                height: ${rem('16px')};
                            }
                        }
                    }
                }
            }
        }

        .buttonWrapper {
            a {
                width: 100%;
            }
        }

        .descriptionWrapper {
            font-size: ${rem('12px')};
            min-height: ${rem('140px')};

            &-payment-link {
                color: ${({ theme }) => theme.colors.red1};
            }
        }
        .descriptionWrapper-gb {
            color: ${({ theme }) => theme.colors.grey24};
        }

        .descriptionWrapper-payment {
            font-size: ${rem(12)};
            padding-bottom: ${rem('10px')};
            color: ${({ theme }) => theme.colors.grey1};

            &-link {
                color: ${({ theme }) => theme.colors.red1};
            }
        }
        .descriptionWrapper-payment-gb {
            color: ${({ theme }) => theme.colors.grey24};
        }

        .priceWrap {
            &--price.OTR,
            .currencyLabel__suffix--OTR {
                font-size: ${({ theme }) => theme.fontSizes.h5} !important;
            }

            &--price,
            .currencyLabel__suffix--PM {
                font-size: ${rem(21)} !important;
            }

            &--bonusLabel {
                font-size: ${({ theme }) => theme.fontSizes.h5};
            }
            &--bonusLink  {
                font-size: ${({ theme }) => theme.fontSizes.h6};
            }
        }
    }
`;
